
import { UseFormReturn } from 'react-hook-form';
import z from 'zod';

export type Styles = { [key: string]: string }

export type ConnectionsForm = any // Use the form type from Connections after export if desired

export type SectionProps = {
  form: Pick<UseFormReturn<ConnectionsForm>, 'watch' | 'setValue'>
  styles:  Styles
}

// General auth fields schema for reuse
export const authFieldsSchema = z.object({
  basic: z
    .object({
      username: z.string().nullable(),
      password: z.string().nullable(),
    })
    .optional()
    .default({ username: '', password: '' }),
  oauth: z
    .object({
      token_url: z.string().url().optional().nullable().or(z.literal('')),
      client_id: z.string().optional().nullable(),
      client_secret: z.string().optional().nullable(),
      scope: z.string().optional().nullable(),
    })
    .optional()
    .default({ token_url: '', client_id: '', client_secret: '', scope: '' }),
  obo: z
    .object({
      token_url: z.string().optional().nullable(),
      audience: z.string().optional().nullable(),
      resource: z.string().optional().nullable(),
      issuer_discovery: z.string().optional().nullable(),
    })
    .optional()
    .default({ token_url: '', audience: '', resource: '', issuer_discovery: '' }),
  saml: z
    .object({
      token_url: z.string().optional().nullable(),
      issuer: z.string().optional().nullable(),
      audience: z.string().optional().nullable(),
      private_key: z.string().optional().nullable(),
      certificate: z.string().optional().nullable(),
      client_id: z.string().optional().nullable(),
      scope: z.string().optional().nullable(),
      client_username: z.string().optional().nullable(),
      client_password: z.string().optional().nullable(),
      testNameId: z.string().optional().nullable(),
    })
    .optional()
    .default({ token_url: '', issuer: '', audience: '', private_key: '', certificate: '', client_id: '', scope: '', client_username: '', client_password: '', testNameId: '' }),
  apikey: z
    .object({
      key_name: z.string().optional().nullable(),
      key_value: z.string().optional().nullable(),
      in: z.enum(['header', 'query']).optional().default('header'),
    })
    .optional()
    .default({ key_name: '', key_value: '', in: 'header' }),
  azure_ad_sp: z
    .object({
      tenantId: z.string().optional().nullable(),
      clientId: z.string().optional().nullable(),
      clientSecret: z.string().optional().nullable(),
    })
    .optional()
    .default({ tenantId: '', clientId: '', clientSecret: '' }),
  sql_auth: z
    .object({
      username: z.string().optional().nullable(),
      password: z.string().optional().nullable(),
    })
    .optional()
    .default({ username: '', password: '' }),
});
